// extracted by mini-css-extract-plugin
export default {"filterBody":"Filters_filterBody__N19Bd"};